import { Building2 } from "lucide-react";
import { clients } from "@/data/clients";

export default function ClientMarquee() {
  // Duplicate the list twice so translateX(-50%) loops seamlessly.
  const track = [...clients, ...clients];
  return (
    <div className="ye-marquee" data-testid="client-marquee" aria-label="Clients">
      <div className="ye-marquee-track">
        {track.map((c, idx) => (
          <div className="ye-marquee-item" key={`${c.name}-${idx}`}>
            {c.placeholder ? (
              <div className="ye-client-chip" aria-label={c.name}>
                <Building2 size={20} />
                <span>Client Logo</span>
              </div>
            ) : (
              <img src={c.logo} alt={c.name} loading="lazy" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
